// src/context.tsx
import { createContext } from "react";
var AnalyticsContext = createContext({
  page: () => {
  },
  track: () => {
  }
});

export {
  AnalyticsContext
};
//# sourceMappingURL=chunk-TRBEEQLV.mjs.map